import axios from 'axios';

export default axios.create({
  baseURL: 'https://a00dbx4j59.execute-api.eu-west-1.amazonaws.com/Prod',
  headers: {}
});